import { colors } from 'theme'

export const defaultThemeReferenceBookStyles = {
    backgroundMain: colors.white,
}
